{{#if errorText }}
  <p class="error-message error-message--email">{{ errorText }}</p>
{{/if}}

